


















import { defineComponent } from "@vue/composition-api";
import PlaceModel from "@/ts/models/placeClass";
import ImageModel from "@/ts/models/imageClass";
import TinyAvatar from "@c/atoms/user/TinyAvatar.vue";

export default defineComponent({
  name: "PlaceChip",

  components: {
    TinyAvatar
  },

  props: {
    place: {
      type: Object as () => PlaceModel
    }
  },

  setup(props) {
    var image;

    if (props.place && props.place.image) {
      image = props.place.image;
    } else {
      image = new ImageModel();
    }

    return { image };
  }
});
